export const getCurrentWorkflowCategoryLangKey = (header: string) => {
  return header === 'Human resource' ? 'human_resource' : header.toLowerCase()
}

export const getWorkflowInputValueKeyByLangKey = (
  header: string,
  templateLangKey: string,
  inputLangKey: string,
  value: string
): string => {
  return `workflows.${getCurrentWorkflowCategoryLangKey(
    header
  )}.${templateLangKey}.inputs.${inputLangKey}.${value}`
}
